import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import ArticlePage from '../pages/article/page';
import DocumentPage from '../pages/document/page';
import ContactPage from '../pages/contact/page';
import BlogPage from '../pages/blog/page';
import BlogDetailPage from '../pages/blog/[slug]/page';
import AdminPage from '../pages/admin/page';
import CategoriesPage from '../pages/admin/categories/page';
import AuthorsPage from '../pages/admin/authors/page';
import SitemapPage from '../pages/sitemap/page';
import RobotsPage from '../pages/robots/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/article/:slug',
    element: <ArticlePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/admin/categories',
    element: <CategoriesPage />,
  },
  {
    path: '/admin/authors',
    element: <AuthorsPage />,
  },
  {
    path: '/sitemap',
    element: <SitemapPage />,
  },
  {
    path: '/robots',
    element: <RobotsPage />,
  },
  {
    path: '/document',
    element: <DocumentPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
